export const VERIFICATION_PENDING = 'VERIFICATION_PENDING';
export const AWAITING_PROCESSING = 'AWAITING_PROCESSING';
export const IN_PROCESS = 'IN_PROCESS';
export const PACKED_READY = 'PACKED_READY';
export const OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY';
export const COMPLETED = 'COMPLETED';
export const CANCELED = 'CANCELED';
export const REMOVED = 'REMOVED';



// WEBPACK FOOTER //
// ./src/const/orderStatus.js